module.exports = __webpack_public_path__ + "img/menu14.abe22044.png";